import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { SurveyParams } from '../data/model/surveyParams'
import { SurveyIdContext } from './SurveyIdContext'

export const useSurveyId = () => {
  const { surveyId: routeSurveyId } = useParams<keyof SurveyParams>()
  const contextSurveyId = useContext(SurveyIdContext)
  // Route param wins (single-market and per-market routes always carry :surveyId).
  // The context fallback only applies inside a SurveyIdProvider — i.e. the multi-market
  // editor, where there is no :surveyId in the URL.
  const surveyId = routeSurveyId ?? contextSurveyId

  if (!surveyId) {
    throw new Error('Missing survey ID required for route')
  }

  return surveyId
}
